import React, { useState } from "react";
import "../../styles/Navbar.css";
import logoNoText from "../../assets/images/javelynxnotextlogo.png";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar__logo">
        <img src={logoNoText} alt="JaveLynks Logo" />
      </div>

      <ul
        className={`navbar__links ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(false)}
      >
        <li>
          <a href="#hero">Home</a>
        </li>
        <li>
          <a href="#identity">About</a>
        </li>
        <li>
          <a href="#services">Services</a>
        </li>
        <li>
          <a href="#industries">Industries</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <div className="navbar__actions">
        <a href="#contact" className="btn">
          Get Started
        </a>
      </div>

      {/* Hamburger Icon */}
      <div
        className={`hamburger ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </nav>
  );
}

export default Navbar;
